module.exports = __webpack_public_path__ + "static/media/icon-developer.cdea20e7.png";